import React, { Component } from "react";
import Input from "upn-component-input";

export default class TextInput extends Component {
  static propTypes = {
    className: Input.propTypes.className,
    value: Input.propTypes.value,
    minLength: Input.propTypes.minLength,
    maxLength: Input.propTypes.maxLength,
    size: Input.propTypes.size,
    onChange: Input.propTypes.onChange,
    placeholder: Input.propTypes.placeholder,
    disabled: Input.propTypes.disabled
  };

  render = () => {
    let classNames = ["upn-component-text-input"];
    if (this.props.className) {
      classNames.push(this.props.className);
    }
    return (
      <Input
        className={classNames.join(" ")}
        value={this.props.value}
        minLength={this.props.minLength}
        maxLength={this.props.maxLength}
        size={this.props.size}
        onChange={this.props.onChange}
        placeholder={this.props.placeholder}
        disabled={this.props.disabled}
      />
    );
  };
}
